export default __webpack_public_path__ + "static/media/Fisher & Paykel.201bf716.svg";